var SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};

SCM.SharedWidgets.Scite = (function($) {
    return {
        init: init,
    };

    const EscapeKeyCode = 27;
    var $containerDiv = null;
    var $contentDiv = null;

    function init() {
        $containerDiv = $('.scite-badge');

        observeSciteContent();

        $containerDiv.on('focusin', function (event) {
            $contentDiv = getContentDiv($containerDiv, $contentDiv);
        });

        $containerDiv.on('keydown', function (event) {
            if (isActivationKey(event)
                && isEventOutsideContent($contentDiv, event)) {
                event.preventDefault();
                showWidget($contentDiv);
            }
            else if (isEscapeKey(event)) {
                event.preventDefault();
                hideWidget($contentDiv);
            }
        });
        $containerDiv.hover(sciteWidgetMouseEnter, sciteWidgetMouseExit);
    }

    function sciteWidgetMouseEnter() {
        $contentDiv = getContentDiv($containerDiv, $contentDiv);
        showWidget($contentDiv);
    }

    function sciteWidgetMouseExit() {
        $contentDiv = getContentDiv($containerDiv, $contentDiv);
        hideWidget($contentDiv);
    }

    function fixupWidgetPosition($contentDiv) {
        var transformValue = $contentDiv.css('transform');
        var regExToGetTransformValues = /^(matrix\(1, ?0, ?0, ?1, ?)(-?\d+(.\d+)?), ?(-?\d+(.\d+)?)\)$/;
        /* the regular expression is intended to process a transform value with a format like this example:  
           matrix(1, 0, 0, 1, -829, -214).  The scite javascript incorrectly calculates negative positions
           for the popup tooltip in split-view and must be adjusted.  The regular expression provides information on how
           to adjust the transform.  For the given example, the following values will be found in the result array:
           result[1]: "matrix(1, 0, 0, 1, "
           result[2]: -829
           result[4]: -214
           As it turns out the best implementation is to simply override the position values rather than override just the negative
           values so result[2] and result[4] are not used below to determine if we should override the results.  
           However, the regular expression is kept in case this information is needed in the future. 
        */
        var result = regExToGetTransformValues.exec(transformValue);
        if (result && result.length >= 2) {
            var leftOffset = $containerDiv.width() + 50;
            var topOffset = -100;
            if ($(window).width() < 768) {
                leftOffset = 0;
                var topOffset = 50;
            }
            var sciteBadgePosition = $containerDiv.position();
            var horizontalPosition = sciteBadgePosition.left + leftOffset;
            var verticalPosition = sciteBadgePosition.top + topOffset;
            transformValue = result[1] + horizontalPosition + ',' + verticalPosition + ')';
            $contentDiv.css('transform', transformValue);
        }
    }

    function isSplitView() {
        var splitViewDiv = $contentDiv.parents('[class*="SplitView"]'); 
        return splitViewDiv.length > 0;
    }
    function getContentDiv($containerDiv, $contentDiv) {
        if ($contentDiv) {
            return $contentDiv;
        }

        $contentDiv = $containerDiv.children().eq(1);
        $contentDiv.on('focusout', function (event) {
            if (isFocusOutsideContent($contentDiv, event)) {
                hideWidget($contentDiv);
            }
        });

        disableTabNavigationOnLinks($contentDiv);
        return $contentDiv;
    }
    
    function showWidget($contentDiv) {
        if (isSplitView()) {
            fixupWidgetPosition($contentDiv);
        }
        $contentDiv.addClass('scite-tooltip-visible');
        enableTabNavigationOnLinks($contentDiv);
    }

    function hideWidget($contentDiv) {
        $contentDiv.removeClass('scite-tooltip-visible');
        disableTabNavigationOnLinks($contentDiv);
    }

    function disableTabNavigationOnLinks($div) {
        const $links = $div.find('a');
        $links.attr('tabindex', '-1');
    }

    function enableTabNavigationOnLinks($div) {
        const $links = $div.find('a');
        $links.removeAttr('tabindex');
    }

    function isActivationKey(event) {
        return event.key === 'Enter' || event.key === ' ';
    }

    function isEscapeKey(event) {
        return event.key === "Escape" || event.keyCode === EscapeKeyCode;
    }

    function isEventOutsideContent($contentDiv, event) {
        return !$contentDiv.has(event.target).length;
    }

    function isFocusOutsideContent($contentDiv, event) {
        return !$contentDiv.has(event.relatedTarget).length;
    }

    function observeSciteContent() {
        if (!window.MutationObserver) {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-fetched') {
                    var $container = $(mutation.target);
                    if ($container.hasClass('scite-badge') && $container.attr('data-fetched') === 'true') {
                        checkAndHideEmptyWidget($container);
                    }
                }
            });
        });

        $('.scite-badge').each(function () {
            observer.observe(this, { attributes: true, attributeFilter: ['data-fetched'] });
        });
    }

    function checkAndHideEmptyWidget($container) {
        var $content = $container.children().eq(0);
        
        if (shouldShowZero($container)) {
            return;
        }
        
        if ($content.length > 0 && !hasNonZeroContent($content)) {
            $container.closest('.widget-DynamicWidgetLayout').addClass('scite-widget-hidden');
        }
    }

    function shouldShowZero($container) {
        return $container.attr('data-show-zero') === 'true';
    }

    function hasNonZeroContent($contentDiv) {
        if (!$contentDiv || $contentDiv.length === 0) {
            return false;
        }

        var textContent = $contentDiv.text();
 
        return /[1-9]/.test(textContent); 
    }

})(jQuery);